export default __webpack_public_path__ + "static/media/Cyan Yothian War-Mare.e5a3eb1b.jpg";